import { render, staticRenderFns } from "./SelectCoin.vue?vue&type=template&id=dc8ddf24"
import script from "./SelectCoin.vue?vue&type=script&lang=js"
export * from "./SelectCoin.vue?vue&type=script&lang=js"
import style0 from "./SelectCoin.vue?vue&type=style&index=0&id=dc8ddf24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports